import { WebApiConfig } from '../dashboard-engine/datasources/misc/webApi/Config';
import API from './API';
import { handleError, handleResponse } from './util';

export const Post = (config: WebApiConfig) => API.post('web/request', config).then(handleResponse).catch(handleError);
